/* unplugin-vue-components disabled */import { render } from "./tcTree.vue?vue&type=template&id=4abcd4a9&scoped=true"
import script from "./tcTree.vue?vue&type=script&lang=js"
export * from "./tcTree.vue?vue&type=script&lang=js"

import "./tcTree.vue?vue&type=style&index=0&id=4abcd4a9&scoped=true&lang=scss"

import exportComponent from "E:\\A_Project\\TC-project\\front-abroad-tms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abcd4a9"]])

export default __exports__